import { render } from "./HardwareForm.vue?vue&type=template&id=2bd66836&scoped=true"
import script from "./HardwareForm.vue?vue&type=script&lang=js"
export * from "./HardwareForm.vue?vue&type=script&lang=js"

import "./HardwareForm.vue?vue&type=style&index=0&id=2bd66836&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd66836"]])

export default __exports__